export const TRANSLATIONS = {
    EN: {
        TAGS: {
            INCORPORATION_INFORMATION: 'Incorporation information',
            AOA: 'Articles of association',
            KVK: 'Extract chamber of commerce',
            UBO_EXTRACT: 'Extract UBO register',
            ORG_CHART: 'Organizational chart',
            CONCEPT: 'Concept deed',
            CONCEPT_COVER_LETTER: 'Concept cover letter',
            CONCEPT_TRANSFER_DEED: 'Concept transfer deed',
            CONCEPT_TRANSLATION: 'Translation of concept deed',
            POA: 'Power of Attorney',
            PDC: 'Personal Data Card',
            DEED: 'Deed',
            TRANSFER_DEED: 'Transfer deed',
            IDENTIFICATION: 'Identification',
            LIQUIDATION_KVK: 'Liquidation CoC form',
            LIQUIDATION_RESOLUTION: 'Liquidation resolution',
            INCORPORATION_DOCUMENTATION: 'Incorporation documents',
            SIGNING_LOG: 'Signing log',
            TRANSLATION: 'Translation',
            COVER_LETTER: 'Cover letter',
            SHR: 'Shareholder register',
            TAX: 'Tax',
            CONTRACT: 'Contract',
            FULLY_PAID_PROOF: 'Proof of payment',
            UBO_DECLARATION: 'UBO declaration',
            PEP: 'PEP',
            KVK_EXACT: 'CoC extract',
            RESULT: 'Result',
            UTILITY_BILL: 'Proof of address or Utility bill',
            STATUTES: 'Statutes',
            CERTIFICATE_HOLDER_REGISTER: 'Certificate holder register',
            OTHER: 'Other document',
        },
    },
    NL: {
        TAGS: {
            INCORPORATION_INFORMATION: 'Oprichting informatie',
            DEED: 'Akte van oprichting',
            AOA: 'Statuten',
            KVK: 'KvK uittreksel',
            UBO_EXTRACT: 'Uittreksel ubo register',
            UBO_DECLARATION: 'UBO verklaring',
            ORG_CHART: 'Organogram',
            CONCEPT: 'Conceptakte',
            CONCEPT_COVER_LETTER: 'Concept begeleidende brief',
            CONCEPT_TRANSFER_DEED: 'Concept Inbreng akte',
            CONCEPT_TRANSLATION: 'Vertaling van concept akte',
            POA: 'Volmacht',
            PDC: 'Personal Data Card',
            TRANSFER_DEED: 'Inbreng akte',
            IDENTIFICATION: 'Identificatie',
            LIQUIDATION_KVK: 'Liquidatie KvK formulier',
            LIQUIDATION_RESOLUTION: 'Liquidatie besluit',
            INCORPORATION_DOCUMENTATION: 'Oprichtingsdocumenten',
            SIGNING_LOG: 'Onderteken log',
            TRANSLATION: 'Vertaling',
            COVER_LETTER: 'Begeleidende brief',
            SHR: 'Aandeelhoudersregister',
            TAX: 'Fiscaal',
            CONTRACT: 'Contract',
            FULLY_PAID_PROOF: 'Volstort bewijs',
            PEP: 'PEP',
            KVK_EXACT: 'KvK uittreksel',
            RESULT: 'Resultaat',
            UTILITY_BILL: 'Energierekening',
            STATUTES: 'Statuten',
            CERTIFICATE_HOLDER_REGISTER: 'Certificaathoudersregister',
            OTHER: 'Ander document',
        },
    },
};
